{
  "es": {
    "ai": {
      "activation": {
        "activate": "Activar",
        "activated": "El asistente de IA está activado para {client}.",
        "agreement_required": "Marca primero la casilla de conformidad.",
        "deactivated": "El asistente de IA está desactivado para {client}.",
        "not_now": "Ahora no",
        "prompt": {
          "agreement": "En nombre de {client}, doy mi conformidad a Google Cloud como subencargado del tratamiento para esta función.",
          "dpa_label": "Acuerdo de tratamiento de datos actualizado",
          "dpa_url": "https://ziggu.io/terms-and-conditions-13-10-2026",
          "intro": "Resume conversaciones y recibe propuestas de respuesta. Prueba gratuita hasta el 31 de diciembre de 2026.",
          "processing": "Para usar el asistente, el texto de las conversaciones se procesa mediante Google Cloud (Gemini) dentro de la UE. Google no utiliza estos datos para entrenar modelos.",
          "retention": "Conservamos las conversaciones con el asistente durante {count} mes. | Conservamos las conversaciones con el asistente durante {count} meses.",
          "settings": "Puedes activar o desactivar el asistente en cualquier momento en la configuración, en {features} > {conversations}.",
          "title": "Nuevo: asistente de IA para tu equipo de proyecto"
        },
        "settings": {
          "description": "Resume conversaciones y propone respuestas. Para activarlo, debes dar tu conformidad a Google Cloud como subencargado del tratamiento.",
          "impersonation": "Solo los empleados con el rol de 'Propietario' pueden activarlo o desactivarlo. No es posible durante una suplantación.",
          "owner_only": "Pide a un propietario que active el asistente de IA.",
          "owner_only_enabled": "Solo un propietario puede desactivar el asistente de IA.",
          "title": "Asistente de IA",
          "toggle": "Asistente de IA en conversaciones"
        },
        "snoozed": "Puedes activar el asistente de IA más tarde en la configuración, en {features} > {conversations}."
      },
      "assistant": {
        "all_projects": "Todos los proyectos",
        "cap": {
          "action": "Iniciar una nueva conversación",
          "message": "Has alcanzado el límite de conversaciones."
        },
        "empty_state": {
          "subtitle": "Pregúntame lo que quieras sobre tus clientes",
          "title": "¿En qué puedo ayudarte?"
        },
        "errors": {
          "budget_reached": "El presupuesto de IA de este mes se ha agotado. Contacta con Ziggu para aumentarlo.",
          "generic": "Algo ha salido mal. Inténtalo de nuevo."
        },
        "history": {
          "empty": "Todavía no hay conversaciones anteriores",
          "title": "Conversaciones anteriores"
        },
        "input": {
          "disclaimer": "Los resultados pueden ser inexactos. Verifica siempre la información importante.",
          "hint": "Intro para enviar · Mayús+Intro para nueva línea",
          "placeholder": "Pregunta sobre tus clientes..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "¿Cómo configuro las notificaciones?",
          "help_project_settings": "¿Dónde encuentro la configuración del proyecto?",
          "open_decisions": "¿Qué decisiones siguen abiertas?",
          "unassigned_units": "¿Qué unidades todavía no tienen cliente?"
        },
        "support_cta": {
          "action": "Contactar con soporte",
          "prompt": "¿No es la respuesta que buscabas?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Todos los módulos",
          "assistant": "Asistente",
          "conversation_agent": "Agente de conversación",
          "label": "Módulo",
          "translation": "Traducción"
        },
        "allowance": {
          "edit": "Editar presupuesto"
        },
        "allowance_boost": {
          "action": "Aumentar temporalmente",
          "action_short": "Aumentar",
          "amount_label": "Importe adicional",
          "existing": "Ya hay un aumento de {amount} activo en este periodo. Este importe se suma.",
          "expires": "Se suma al presupuesto solo para este periodo y caduca el {date}.",
          "expires_next_reset": "Se suma al presupuesto solo para este periodo y caduca en el próximo reinicio.",
          "save": "Añadir aumento",
          "saved": "Aumento de {amount} añadido"
        },
        "allowance_history": {
          "empty": "Todavía no hay cambios",
          "empty_hint": "Este cliente sigue con el presupuesto que se le asignó.",
          "entry": "{field}: {before} → {after}",
          "package_amount": "importe del paquete",
          "title": "Historial del presupuesto",
          "unknown_author": "Desconocido"
        },
        "chat_detail": {
          "employee": "Empleado",
          "empty": "Este chat no tiene mensajes",
          "feedback": {
            "down": "Mala respuesta",
            "up": "Buena respuesta"
          },
          "text_hidden": "No compartido por el empleado",
          "title": "Conversación"
        },
        "chats": {
          "columns": {
            "client": "Cliente",
            "cost": "Coste",
            "employee": "Empleado",
            "intent": "Intención",
            "ticket": "Ticket",
            "turns": "Turnos",
            "when": "Cuándo"
          },
          "empty": "Sin chats en este periodo",
          "feedback_label": "Valoración",
          "feedbacks": {
            "all": "Cualquier valoración",
            "down": "Pulgar abajo",
            "up": "Pulgar arriba"
          },
          "intent_label": "Intención",
          "open": "Abrir conversación",
          "title": "Chats",
          "via": "vía {name}"
        },
        "client": {
          "allowance_boost": "{amount} adicional hasta el {date}",
          "allowance_boost_next_reset": "{amount} adicional hasta el próximo reinicio",
          "allowance_free": "{amount} gratuito",
          "allowance_paid": "{amount} de pago",
          "employees_active": "{count} empleado activo | {count} empleados activos",
          "over_since": "Superado desde el {date}",
          "title": "{name} · IA",
          "used": "{used} de {allowance} usados"
        },
        "clients": {
          "allowance_split": "Gratuito {free} · De pago {paid}",
          "allowance_split_boost": "Gratuito {free} · De pago {paid} · Adicional {boost}",
          "columns": {
            "actions": "Acciones",
            "allowance": "Presupuesto",
            "chats": "Chats en el periodo",
            "client": "Cliente",
            "spend": "Gasto en el periodo",
            "status": "Estado",
            "used": "Usado este mes"
          },
          "empty": "Ningún cliente usó IA en este periodo",
          "export": "Exportar",
          "title": "Clientes"
        },
        "empty_hint": "No hay resultados para este módulo y periodo.",
        "intent_mix": {
          "empty": "Sin chats en este periodo",
          "row": "{chats} chat · {amount} | {chats} chats · {amount}",
          "title": "Distribución por intención"
        },
        "intents": {
          "all": "Todas las intenciones",
          "draft": "Redactar una respuesta",
          "none": "Sin intención",
          "question": "Preguntar",
          "summary": "Resumen"
        },
        "kpi": {
          "clients_active": "Clientes activos",
          "employees_active": "Empleados activos",
          "spend_month": "Gasto este mes",
          "spend_month_detail": "Mes natural en curso",
          "spend_range": "Gasto en el periodo",
          "spend_range_detail": "{count} chat en este periodo | {count} chats en este periodo",
          "spend_today": "Gasto de hoy",
          "tickets_assisted": "Tickets asistidos"
        },
        "load_failed": {
          "description": "Recarga la página o elige otro periodo.",
          "title": "No se pudo cargar el uso de IA"
        },
        "range": {
          "label": "Periodo"
        },
        "spend": {
          "empty": "Sin gasto en este periodo",
          "monthly_empty": "Sin gasto en los últimos {months} meses",
          "monthly_hint": "Últimos {months} meses · no depende del periodo seleccionado",
          "monthly_title": "Coste por mes",
          "monthly_total": "{amount} en los últimos {months} meses · no depende del periodo seleccionado",
          "title": "Gasto por día",
          "total": "{amount} en el periodo",
          "view": {
            "label": "Mostrar gasto",
            "per_day": "Por día",
            "running_total": "Acumulado"
          }
        },
        "status": {
          "over": "Presupuesto superado",
          "over_days": "Superado · 1 día | Superado · {count} días"
        },
        "title": "Uso de IA"
      },
      "settings": {
        "budget": {
          "amount_error": "Escribe un importe como 2 o 2.50",
          "boost_label": "Aumento temporal",
          "boost_label_until": "Aumento temporal hasta el {date}",
          "description": "Límite de coste mensual para el uso de IA (fase de prueba). Se recalcula según el uso de tokens en todas las conversaciones de este mes.",
          "free_label": "Presupuesto gratuito",
          "override_help": "Déjalo vacío para usar el importe del paquete ({amount}).",
          "override_label": "Presupuesto gratuito personalizado",
          "paid_label": "Presupuesto de pago",
          "save": "Guardar",
          "title": "Presupuesto mensual",
          "total_label": "Presupuesto total",
          "usage_label": "Usado este mes",
          "usage_of": "Usado este mes, de {amount}",
          "use_package_amount": "Usar el importe del paquete"
        },
        "description": "Configuración de las funciones de IA en tu organización.",
        "title": "Configuración de IA",
        "usage": {
          "description": "Cuánto se ha usado del saldo de IA de este mes. Al llegar al 100 %, las funciones de IA se detienen hasta que el saldo se renueve el mes que viene.",
          "title": "Uso de IA"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Ajustar",
          "ask": "Preguntar",
          "draft": "Redactar una respuesta",
          "draft_empty": "Aún no hay mensajes a los que responder",
          "follow_up": "Seguimiento",
          "follow_up_stop": "Dejar de hacer seguimiento",
          "new": "Nueva pregunta",
          "summary": "Resumir la conversación",
          "summary_empty": "Aún no hay mensajes que resumir",
          "use_as_reply": "Usar como respuesta"
        },
        "adjusting_draft": "Ajuste de este borrador",
        "beta": "Beta",
        "beta_tooltip": "Gratis hasta finales de 2026. Después, el uso será limitado.",
        "budget": {
          "description": "El presupuesto de IA de este mes se ha agotado. Las respuestas anteriores siguen disponibles.",
          "request": "Hemos agotado el presupuesto de IA de este mes y queremos aumentarlo.",
          "request_low": "Casi hemos agotado el presupuesto de IA de este mes y queremos aumentarlo.",
          "title": "Presupuesto de IA alcanzado",
          "warn": "{percent} % del presupuesto de IA de este mes utilizado."
        },
        "cap": "Este chat se ha hecho largo. Mejor haz una pregunta nueva.",
        "collapse": "Ocultar asistente",
        "conversation": "Conversación",
        "digest": {
          "decisions_open": "ninguna decisión abierta | 1 decisión abierta | {count} decisiones abiertas",
          "installments_unpaid": "ninguna cuota impagada | 1 cuota impagada | {count} cuotas impagadas",
          "issues_open": "ninguna incidencia de posventa abierta | 1 incidencia de posventa abierta | {count} incidencias de posventa abiertas",
          "nothing_open": "Nada pendiente en esta unidad",
          "overdue": "{count} vencidas | {count} vencida | {count} vencidas",
          "title": "De un vistazo"
        },
        "earlier_answers": "Respuestas anteriores",
        "empty": "Pregunta algo sobre esta conversación o empieza con una de estas.",
        "expand": "Mostrar asistente",
        "feedback": {
          "bad": "Mala respuesta",
          "consent": "Ziggu verá esta conversación. Puede contener nombres y datos de clientes.",
          "consent_shared": "Esta conversación ya está compartida con Ziggu.",
          "good": "Buena respuesta",
          "note": "¿Qué debería haber dicho? (opcional)",
          "send": "Enviar",
          "share": "Compartir con Ziggu",
          "stop_sharing": "Dejar de compartir",
          "thanks": "Gracias por tu opinión.",
          "thanks_shared": "Gracias. Compartida con Ziggu.",
          "undo": "Deshacer"
        },
        "following_up": "Seguimiento de esta respuesta",
        "footer": "El soporte de Ziggu solo lo lee si lo compartes o das acceso a Ziggu. Las respuestas las genera una IA y pueden contener errores.",
        "footer_shared": "Has compartido esta conversación con Ziggu. Las respuestas las genera una IA y pueden contener errores.",
        "input": {
          "adjust_draft": "Ajusta este borrador, p. ej. más corto o más formal",
          "follow_up": "Haz una pregunta de seguimiento",
          "label": "Tu pregunta",
          "placeholder": "Pregunta por esta conversación"
        },
        "links": {
          "aftercare": "Posventa",
          "decisions": "Decisiones",
          "financials": "Finanzas"
        },
        "placeholders": {
          "confirm": {
            "accept": "Enviar igualmente",
            "header": "¿Enviar con datos sin completar?",
            "message": "El asistente dejó 1 dato sin completar en esta respuesta. | El asistente dejó {count} datos sin completar en esta respuesta."
          },
          "remaining": "1 dato por completar | {count} datos por completar"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Reemplazar",
            "header": "¿Reemplazar lo que escribiste?",
            "message": "El borrador reemplaza el texto del cuadro de respuesta."
          }
        },
        "resize": "Cambiar el ancho del asistente",
        "suggestions": {
          "history": "¿Cuál es el historial con este cliente?",
          "issues_open": "¿Cuántas incidencias de posventa siguen abiertas?",
          "undecided": "¿Qué no ha decidido todavía este cliente?"
        },
        "thinking": "El asistente está trabajando...",
        "title": "Asistente"
      }
    }
  }
}
